var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { I18N } from "aurelia-i18n";
import { LookupValueRequest, LookupValueQuery, OrderByEnum } from "../../../../models/lookups/lookup.models";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { OperatorClientService } from "../../../../services/modules/operator-client.service";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
var BrandSelection = /** @class */ (function () {
    function BrandSelection() {
        this.selected = true;
        this.newBrandName = "";
    }
    return BrandSelection;
}());
// The API is camelCase, but read both casings so a serializer change cannot blank the page.
function pick(source, name) {
    if (!source)
        return undefined;
    var pascal = name.charAt(0).toUpperCase() + name.slice(1);
    return source[name] !== undefined ? source[name] : source[pascal];
}
function pickArray(source, name) {
    var value = pick(source, name);
    return Array.isArray(value) ? value : [];
}
var CloneOperator = /** @class */ (function () {
    function CloneOperator(i18N, lookupService, operatorClientService, notificationService) {
        this.i18N = i18N;
        this.lookupService = lookupService;
        this.operatorClientService = operatorClientService;
        this.notificationService = notificationService;
        this.operators = [];
        this.selectedOperator = null;
        this.brands = [];
        this.newOperatorName = "";
        this.copySourceLook = true;
        this.useBaseLook = false;
        this.checking = false;
        this.cloning = false;
        this.checkResult = null;
        this.checkPassed = false;
        this.checkErrors = [];
        this.checkWarnings = [];
        this.checkInfo = [];
        this.checkPreview = [];
        this.checkRaw = null;
        this.checkedSignature = null;
        this.result = null;
    }
    CloneOperator.prototype.attached = function () {
        var _this = this;
        var request = new LookupValueRequest();
        request.lookupValueQuery = LookupValueQuery.operators;
        request.setOverrideMetaDataFiltering(OrderByEnum.NameASC);
        this.lookupService.getLookup(request).then(function (x) { return _this.operators = x.values; });
    };
    CloneOperator.prototype.onOperatorSelected = function (event) {
        var _this = this;
        this.selectedOperator = event.detail.item;
        this.brands = [];
        this.newOperatorName = "";
        this.copySourceLook = true;
        this.useBaseLook = false;
        this.reset();
        if (!this.selectedOperator)
            return;
        this.newOperatorName = this.selectedOperator.name + " Copy";
        var request = new LookupValueRequest();
        request.lookupValueQuery = LookupValueQuery.brands;
        request.setOverrideMetaDataFiltering(OrderByEnum.NameASC);
        request.parameters = this.selectedOperator.id.toString();
        this.lookupService.getLookup(request).then(function (x) {
            _this.brands = x.values.map(function (b) {
                var selection = new BrandSelection();
                selection.sourceBrandId = b.id;
                selection.sourceBrandName = b.name;
                selection.newBrandName = b.name + " Copy";
                return selection;
            });
        });
    };
    CloneOperator.prototype.reset = function () {
        this.checkResult = null;
        this.checkPassed = false;
        this.checkErrors = [];
        this.checkWarnings = [];
        this.checkInfo = [];
        this.checkPreview = [];
        this.checkRaw = null;
        this.checkedSignature = null;
        this.result = null;
    };
    Object.defineProperty(CloneOperator.prototype, "selectedBrands", {
        get: function () {
            return this.brands.filter(function (b) { return b.selected; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CloneOperator.prototype, "signature", {
        // Any edit to the inputs changes this, which drops the green check and disables Clone again.
        get: function () {
            if (!this.selectedOperator)
                return "";
            return JSON.stringify({
                operatorId: this.selectedOperator.id,
                operatorName: this.newOperatorName,
                useBaseLook: this.useBaseLook,
                brands: this.selectedBrands.map(function (b) { return [b.sourceBrandId, b.newBrandName]; })
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CloneOperator.prototype, "isCheckStale", {
        get: function () {
            return !!this.checkResult && this.checkedSignature !== this.signature;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CloneOperator.prototype, "hasInputs", {
        get: function () {
            if (!this.selectedOperator)
                return false;
            if (!this.newOperatorName || !this.newOperatorName.trim())
                return false;
            var chosen = this.selectedBrands;
            if (chosen.length === 0)
                return false;
            return chosen.every(function (b) { return !!b.newBrandName && !!b.newBrandName.trim(); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CloneOperator.prototype, "canCheck", {
        get: function () {
            return this.hasInputs && !this.checking && !this.cloning;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CloneOperator.prototype, "canClone", {
        get: function () {
            return this.checkPassed && !this.isCheckStale && !this.checking && !this.cloning;
        },
        enumerable: false,
        configurable: true
    });
    CloneOperator.prototype.buildRequest = function () {
        return {
            sourceOperatorId: this.selectedOperator.id,
            newOperatorName: this.newOperatorName.trim(),
            brands: this.selectedBrands.map(function (b) { return ({
                sourceBrandId: b.sourceBrandId,
                newBrandName: b.newBrandName.trim()
            }); }),
            useBaseLook: this.useBaseLook
        };
    };
    CloneOperator.prototype.check = function () {
        return __awaiter(this, void 0, void 0, function () {
            var signature, response, isValid, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canCheck)
                            return [2 /*return*/];
                        this.checking = true;
                        this.reset();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        signature = this.signature;
                        return [4 /*yield*/, this.operatorClientService.cloneCheck(this.buildRequest())];
                    case 2:
                        response = _a.sent();
                        this.checkResult = response || {};
                        this.checkErrors = pickArray(response, "errors");
                        this.checkWarnings = pickArray(response, "warnings");
                        this.checkInfo = pickArray(response, "info");
                        this.checkPreview = pickArray(response, "preview");
                        isValid = pick(response, "isValid");
                        this.checkPassed = isValid === true;
                        // Nothing recognisable came back: show it so the mismatch is visible instead of a blank panel.
                        if (isValid === undefined)
                            this.checkRaw = JSON.stringify(response);
                        this.checkedSignature = signature;
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.show(this.i18N.tr("error"), this.errorText(error_1, "clone-operator-check-error"), NotificationType.Error);
                        return [3 /*break*/, 5];
                    case 4:
                        this.checking = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CloneOperator.prototype.clone = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canClone)
                            return [2 /*return*/];
                        this.cloning = true;
                        this.result = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.operatorClientService.clone(this.buildRequest())];
                    case 2:
                        response = _a.sent();
                        this.result = {
                            newOperatorId: pick(response, "newOperatorId"),
                            newOperatorName: pick(response, "newOperatorName"),
                            brands: pickArray(response, "brands"),
                            rowCounts: pickArray(response, "rowCounts"),
                            warnings: pickArray(response, "warnings"),
                            usingExistingOperator: pick(response, "usingExistingOperator") === true
                        };
                        this.checkResult = null;
                        this.checkPassed = false;
                        this.checkedSignature = null;
                        this.notificationService.show(this.i18N.tr("success"), this.i18N.tr("clone-operator-success"), NotificationType.Success);
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        this.notificationService.show(this.i18N.tr("error"), this.errorText(error_2, "clone-operator-error"), NotificationType.Error);
                        return [3 /*break*/, 5];
                    case 4:
                        this.cloning = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CloneOperator.prototype.errorText = function (error, fallbackKey) {
        var message = error && (error.message || error.exceptionMessage);
        return message ? message : this.i18N.tr(fallbackKey);
    };
    CloneOperator = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [I18N,
            LookupClientService,
            OperatorClientService,
            NotificationClientService])
    ], CloneOperator);
    return CloneOperator;
}());
export { CloneOperator };
